import { render } from "./Bookmarks.vue?vue&type=template&id=209001b7&scoped=true"
import script from "./Bookmarks.vue?vue&type=script&lang=js"
export * from "./Bookmarks.vue?vue&type=script&lang=js"

import "./Bookmarks.vue?vue&type=style&index=0&id=209001b7&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-209001b7"]])

export default __exports__